/* eslint-disable react/jsx-key */
import "./SettlementsTable.scss";
import primaryComponents from "../../primaryComponents";
import secondaryComponents from "..";
import useSettlementsTableLogic from "./SettlementsTableLogic";
import { Fragment } from "react";

const SettlementsTable = ({ setHasAccount }) => {
  const {
    instance,
    isFetchingAccounts,
    accountList,
    isOpenDeleteDialog,
    isDeletingAccount,
    selectedAccount,
    isOpenEditDialog,
    isOpenSettlementForm,
    // setSelectedAccount,
    setIsOpenSettlementForm,
    setIsOpenEditDialog,
    setIsOpenDeleteDialog,
    handleDeleteSettlementAccount,
    handleFetchSettlementAccounts,
  } = useSettlementsTableLogic(setHasAccount);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <div>
      <div
        style={{
          background: accountList.length <= 0 ? "none" : "white",
        }}
        className="settlements__table"
      >
        <secondaryComponents.LoaderHelper
          classNames={"mt-3"}
          isLoading={isFetchingAccounts}
        >
          {accountList.length > 0 && (
            <Fragment>
              <div className="settlements__table__header">
                <primaryComponents.Button
                  onClick={() => setIsOpenSettlementForm(true)}
                  classNames={"btn btn--primary"}
                >
                  Add New Bank
                </primaryComponents.Button>
              </div>
              <secondaryComponents.TableHelper
                getTableProps={getTableProps}
                getTableBodyProps={getTableBodyProps}
                headerGroups={headerGroups}
                rows={rows}
                prepareRow={prepareRow}
              >
                <div className="text-center mt-5 mb-5">
                  <h4 className="font-weight-semibold text-center mt-4">
                    No Data Available
                  </h4>
                </div>
              </secondaryComponents.TableHelper>
            </Fragment>
          )}

          {isOpenDeleteDialog && (
            <secondaryComponents.ConfirmDialog
              title="Are you sure you want to delete this
                                account?"
              isOpen={isOpenDeleteDialog}
              setIsOpen={setIsOpenDeleteDialog}
              handler={handleDeleteSettlementAccount}
              isLoading={isDeletingAccount}
            >
              <div
                style={{
                  backgroundColor: "#F3F1FC",
                  padding: "16px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  borderRadius: "8px",
                }}
              >
                <p
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span className="dark--text font-weight-semibold mb-1">
                    Account Name
                  </span>
                  <span>{selectedAccount.account_name}</span>
                </p>
                <p
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span className="dark--text font-weight-semibold mb-1">
                    Account Number
                  </span>
                  <span>{selectedAccount.decrypted_nuban}</span>
                </p>
                <p
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span className="dark--text font-weight-semibold mb-1">
                    Bank Name
                  </span>
                  <span>{selectedAccount.bank_name}</span>
                </p>
              </div>
            </secondaryComponents.ConfirmDialog>
          )}

          {isOpenEditDialog && (
            <secondaryComponents.EditSettlementAccount
              isOpen={isOpenEditDialog}
              setIsOpen={setIsOpenEditDialog}
              settlementAccount={selectedAccount}
              handleFetchSettlementAccounts={handleFetchSettlementAccounts}
            />
          )}
        </secondaryComponents.LoaderHelper>
        {isOpenSettlementForm && (
          <secondaryComponents.AddSettlementAccount
            isOpen={isOpenSettlementForm}
            setIsOpen={setIsOpenSettlementForm}
            handleFetchSettlementAccounts={handleFetchSettlementAccounts}
          />
        )}
      </div>
    </div>
  );
};

export default SettlementsTable;
